import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const BCBenxekhachtable = React.memo(function BCBenxekhachtable(props) {
  const classes = useStyles();
  const { data } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Tổng số bến xe khách</td>
          <td className={classes.tablebc_td}>Đơn vị</td>
          <td className={classes.tablebc_td}>{data.p1_sodonvi}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>
            Tổng số tuyến xe xuất phát tại các bến xe
          </td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{data.p1_tong_sotuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{data.p1_sotuyen_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{data.p1_sotuyen_lientinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến xe buýt</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{data.p1_sotuyen_buyt}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Tổng số lượng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.p1_tong_sophuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.p1_sophuongtien_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>
            {data.p1_sophuongtien_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến xe buýt</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.p1_sophuongtien_buyt}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>4</td>
          <td className={classes.tablebc_td}>Tổng số chuyến xe thực hiện</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{data.p1_tong_sochuyen_th}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{data.p1_sochuyen_noitinh_th}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>
            {data.p1_tyle_sochuyen_noitinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{data.p1_sochuyen_lientinh_th}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>
            {data.p1_tyle_sochuyen_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>5</td>
          <td className={classes.tablebc_td}>Tổng số chuyến xe buýt</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{data.p1_sochuyen_buyt_th}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>6</td>
          <td className={classes.tablebc_td}>
            Tổng số chuyến xe không thực hiện
          </td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{data.p1_tong_sochuyen_kth}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{data.p1_sochuyen_noitinh_kth}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>
            {data.p1_sochuyen_lientinh_kth}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>7</td>
          <td className={classes.tablebc_td}>
            Tổng hành khách vận chuyển thông qua bến
          </td>
          <td className={classes.tablebc_td}>HK</td>
          <td className={classes.tablebc_td}>{data.p1_sokhach_vanchuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>8</td>
          <td className={classes.tablebc_td}>Công suất bến xe</td>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>{data.p1_tyle_congsuat}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCBenxekhachtable.propTypes = {
  data: PropTypes.object,
};
export default BCBenxekhachtable;
